module.exports = __webpack_public_path__ + "static/media/BoundWorx_Data_Sheet_MARBLE.4eeb939f.pdf";